export const CONFIG = {
  USE_INSO_PRICE_RANDOMIZER: 'useInsoPriceRandomizer',
  INSO_PRICE_VARIATIONS: 'insoPriceVariations',
  INSO_PRICE_DEFAULT: 'insoPriceDefault',
};
